import React, { useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TextField } from 'edenred-ui';

import { createRules, FormFields, useOnBlurTrim } from '@epi-forms/helpers';
import {
  city,
  maxLength,
  required as requiredValidation
} from '@epi-helpers/formHelpers/validators';
import { CityFieldProps } from '@epi-models/forms/Controls';

export function CityField({
  disabled = false,
  readOnly = false,
  name = FormFields.City,
  required = true
}: CityFieldProps) {
  const { control, unregister } = useFormContext();
  const { t } = useTranslation();
  const onBlurTrim = useOnBlurTrim(name);
  const validators = [requiredValidation, maxLength(50), city];
  const rules = disabled || readOnly ? undefined : createRules(validators);

  const {
    field: { ref, value, onChange: setValue },
    fieldState: { error }
  } = useController({
    name,
    control,
    rules
  });

  useEffect(() => {
    if (readOnly) {
      unregister(name);
    }
  }, [readOnly]);

  return (
    <TextField
      label={t('controls.city_label')}
      required={required}
      disabled={disabled}
      value={value}
      readOnly={readOnly}
      id={name}
      error={!!error}
      helperText={error?.message}
      inputRef={ref}
      onBlur={onBlurTrim}
      onChange={setValue}
    />
  );
}
